import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

import { mixpanel } from '@/mixpanel'
import { useUnreadMessageCount } from '@/modules/messages/hooks/useUnreadMessageCount'
import { getDropInProps } from '@/modules/shared/animations/dropIn.animation'
import { useLoggedInForMandatee } from '@/modules/trust/hooks/useLoggedInForMandatee'
import { StBadge, StContainer, StIcon } from './MessageIndicator.styled'

function UnreadCountBadge() {
  const { unreadMessageCount } = useUnreadMessageCount()

  if (!unreadMessageCount) return null

  return (
    <motion.div
      {...getDropInProps({
        hidden: {
          y: 0,
          scale: 0,
        },
        transition: {
          delay: 1.4,
        },
      })}
    >
      <StBadge>{unreadMessageCount > 99 ? '99' : unreadMessageCount}</StBadge>
    </motion.div>
  )
}

const MessageIndicator = () => {
  const isLoggedInForMandatee = useLoggedInForMandatee()

  return (
    <Link
      to='/message'
      onClick={() =>
        mixpanel.track('message_center_open', {
          origin,
          is_mandate: isLoggedInForMandatee,
        })
      }
    >
      <StContainer>
        <UnreadCountBadge />
        <StIcon icon={['fal', 'message']} />
      </StContainer>
    </Link>
  )
}

export { MessageIndicator }
